export default __webpack_public_path__ + "static/media/om-token-migration-active.5ac3d45e.svg";